import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBook, FiMic, FiShoppingCart, FiBriefcase, FiUsers } = FiIcons;

const SocialProofBar = () => {
  return (
    <div className="w-full bg-brand-gray-50 border-y border-gray-200 py-8 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-gray-500 text-sm font-medium mb-6 uppercase tracking-wider">Trusted by entrepreneurs creating content for:</p>
        <div className="flex flex-wrap justify-center items-center gap-12 md:gap-20 opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
          <div className="flex items-center gap-3">
            <SafeIcon icon={FiBook} className="text-3xl" />
            <span className="font-bold text-xl">Courses</span>
          </div>
          <div className="flex items-center gap-3">
            <SafeIcon icon={FiUsers} className="text-3xl" />
            <span className="font-bold text-xl">Coaching</span>
          </div>
          <div className="flex items-center gap-3">
            <SafeIcon icon={FiShoppingCart} className="text-3xl" />
            <span className="font-bold text-xl">Ecommerce</span>
          </div>
          <div className="flex items-center gap-3">
            <SafeIcon icon={FiMic} className="text-3xl" />
            <span className="font-bold text-xl">Podcasts</span>
          </div>
          <div className="flex items-center gap-3">
            <SafeIcon icon={FiBriefcase} className="text-3xl" />
            <span className="font-bold text-xl">Agencies</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialProofBar;